/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  RESET,
  RESET_CLAIM_TO_INJURY,
  RESET_DETAIL_OF_MEDICAL_CONDITIONAL,
  GET_CITY_LIST,
  GET_CITY_LIST_SUCCESS,
  GET_PROVINCE_LIST,
  GET_PROVINCE_LIST_SUCCESS,
  GET_COUNTRY_LIST,
  GET_COUNTRY_LIST_SUCCESS,
  GET_CLAIM_TYPES,
  GET_CLAIM_TYPES_SUCCESS,
  VALIDATE_DATE_TIME_OF_EVENT,
  POLICY_VERSION_CHANGED,
  GET_COUNTRY_SUPPORTED_LIST,
  GET_COUNTRY_SUPPORTED_LIST_SUCCESS,
  RESET_FILES_BY_BENEFIT_CODE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormClaimToInjuryState() {
  return {
    type: RESET_CLAIM_TO_INJURY,
  };
}

export function resetDetailOfMedicalConditional() {
  return {
    type: RESET_DETAIL_OF_MEDICAL_CONDITIONAL,
  };
}

export function getCountryList() {
  return {
    type: GET_COUNTRY_LIST,
  };
}

export function getCountryListSuccess(countries) {
  return {
    type: GET_COUNTRY_LIST_SUCCESS,
    countries,
  };
}

export function getCountriesOfxSupported() {
  return {
    type: GET_COUNTRY_SUPPORTED_LIST,
  };
}

export function getCountriesOfxSupportedSuccess(countries) {
  return {
    type: GET_COUNTRY_SUPPORTED_LIST_SUCCESS,
    countries,
  };
}

export function getCityList(stringCity, callback) {
  return {
    type: GET_CITY_LIST,
    stringCity,
    callback,
  };
}

export function getCityListSuccess(cities) {
  return {
    type: GET_CITY_LIST_SUCCESS,
    cities,
  };
}

export function getProvinceList() {
  return {
    type: GET_PROVINCE_LIST,
  };
}

export function getProvinceListSuccess(provinces) {
  return {
    type: GET_PROVINCE_LIST_SUCCESS,
    provinces,
  };
}

export function getClaimTypes(byClaimId) {
  return {
    type: GET_CLAIM_TYPES,
    byClaimId,
  };
}

export function getClaimTypeSuccess(claim) {
  return {
    type: GET_CLAIM_TYPES_SUCCESS,
    claimTypeList: claim.claimTypeList,
    policyTypeId: claim.policyTypeId,
    jsonVersion: claim.jsonVersion,
    showZurichUHC: claim.showZurichUHC,
    policyTypeCode: claim.policyTypeCode,
    policyPlanIds: claim.policyPlanIds,
  };
}

export function checkValidationDateOfEvent(fieldName) {
  return {
    type: VALIDATE_DATE_TIME_OF_EVENT,
    fieldName,
  };
}

export function policyVersionChanged(value) {
  return {
    type: POLICY_VERSION_CHANGED,
    value,
  };
}

export function deleteDocumentsByBenefitCode(benefitCode, claimTypeId) {
  return {
    type: RESET_FILES_BY_BENEFIT_CODE,
    benefitCode,
    claimTypeId,
  };
}


// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/actions.js